(function () {
  const selectors = {
    button: `a[href="#selling_plan_app_container"]`,
    container: `#selling_plan_app_container`,
  };

  const buttons = document.querySelectorAll(selectors.button);
  const container = document.querySelector(selectors.container);

  buttons.forEach((button) => {
    button.addEventListener(`click`, (event) => {
      event.preventDefault();
      // scroll window just just above the container

      var headerOffset = 100;
      var offsetPosition =
        container.getBoundingClientRect().top + window.scrollY - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    });
  });
})();

(function () {
  const selectors = {
    label: "variant-selects label",
  };

  const labels = document.querySelectorAll(selectors.label);

  labels.forEach((label) => {
    label.addEventListener(`click`, (event) => {
      event.preventDefault();
      const input = label.previousElementSibling;
      input.checked = true;
    });
  });
})();
